export default "__VITE_ASSET__BNiZfx7k__"